// extracted by mini-css-extract-plugin
module.exports = {"table":"ProductTable_table__AuyKR"};